"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ExternalLink_1 = require("../ExternalLink");
const useExternalIcon = (iconClass) => {
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        if (containerRef.current) {
            const links = containerRef.current.querySelectorAll('a');
            if (links.length > 0) {
                const externalLink = new ExternalLink_1.ExternalLink(links);
                externalLink.checkLinks(iconClass);
            }
        }
    }, []);
    return containerRef;
};
exports.default = useExternalIcon;
